export const enum Environment {
  stage = 'stage',
  prod = 'production',
  demo = 'demo',
  dev = 'development'
}
